export default String.raw`
{% assign postList = blog.PostList %}
{% include 'partials/common/date-format.html' -%}
{% assign postsLenght = postList.Posts | Size %}
<div class='blog-container' {% if postsLenght == 0 %} style="width: 93%;" {% endif %}>
    {% include 'partials/common/breadcrumbs.html' -%}
    <div class="blog-container__title">
        <h1>{{ translations.BlogNews }}</h1>
        {% if page.GET.seaBlog != null -%}
            <a href="{{ page.CanonicalLink }}" class="selected-filters__item">
                <span>{{ page.GET.seaBlog }}</span>
                <svg>
                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
                </svg>
            </a>
        {% endif -%}
    </div>
	{% if postsLenght != 0 %}
        <div class="blog-container__list">
            {% for post in postList.Posts -%}
                {% include 'partials/blog/blog-item.html' with post %}
            {% endfor -%}
        </div>
        {% include 'partials/common/pagination.html' %}
    {% else %}
        {% include 'partials/common/empty-page.html', title: translations.EmptyBlogList -%}
    {% endif %} 
</div>
`